<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="倍率修正需消耗总体力规则配置" name="betSpinsRule">
            <el-form :inline="true" :model="formPhysicalExertion" class="demo-form-inline">
              <el-row v-for="(item, index, key) in formData.betSpinsRule.value" :key="key">
                <el-form-item label="倍率">
                  <el-input v-model.number="item.k" placeholder="倍率" />
                </el-form-item>
                <el-form-item label="修正需消耗总体力">
                  <el-input v-model.number="item.v" placeholder="修正需消耗总体力 " />
                </el-form-item>
                <el-form-item>
                  <el-button v-if="formData.betSpinsRule.value.length > 1" type="danger" @click="delRule(index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button type="primary" @click="addRule()">新增</el-button>
                <el-button type="primary" @click="saveRule('betSpinsRule')">保存</el-button>
              </el-form-item>
            </el-form>

          </el-tab-pane>
          <el-tab-pane label="体力消耗修正配置" name="spinsLost">

            <el-row :gutter="10" class="mb8">
              <el-col :span="1.5">
                <el-upload
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=> { return importProbUploadSuccess(res, 'spinsLost') }"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:slotWeightChangeCfg:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>

              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:slotWeightChangeCfg:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportData('spinsLost')"
                >导出</el-button>
              </el-col>
            </el-row>

            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.spinsLost" :key="index">
                <el-form-item label="体力/倍率">
                  <el-input v-model="item.key" style="width: 60px;" placeholder="体力/倍率" :prop="'formData.spinsLost.' +index +'.key'" />
                </el-form-item>
                <el-form-item v-for="(child, i, key) in item.value" :key="key" :label="enums[key]">
                  <el-input v-model.trim="item.value[i]" :value="child" style="width: 60px;" :prop="'formData.spinsLost.' +index+i" :placeholder="enums[key]" />
                </el-form-item>
                <el-form-item>
                  <el-button v-if="formData.spinsLost.length > 1" style="margin-top: 10px;" type="danger" @click="removeConfig(index, 'spinsLost')">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button type="primary" @click="addCorrectConfig('spinsLost')">新增</el-button>
                <el-button type="primary" @click="saveRule('spinsLost')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="每6小时体力消耗修正配置" name="spinsLostDay">
            <el-row :gutter="10" class="mb8">
              <el-col :span="1.5">
                <el-upload
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=> { return importProbUploadSuccess(res, 'spinsLostDay') }"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:slotWeightChangeCfg:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>

              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:slotWeightChangeCfg:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportData('spinsLostDay')"
                >导出</el-button>
              </el-col>
            </el-row>
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.spinsLostDay" :key="index">
                <el-form-item label="体力/倍率">
                  <el-input v-model="item.key" style="width: 60px;" placeholder="体力总消耗" :prop="'formData.spinsLostDay.' +index +'.key'" />
                </el-form-item>
                <el-form-item v-for="(child, i, key) in item.value" :key="key" :label="enums[key]">
                  <el-input v-model.trim="item.value[i]" :value="child" style="width: 60px;" :prop="'formData.spinsLostDay.' +index+i" :placeholder="enums[key]" />
                </el-form-item>
                <el-form-item>
                  <el-button v-if="formData.spinsLostDay.length > 1" style="margin-top: 10px;" type="danger" @click="removeConfig(index, 'spinsLostDay')">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button type="primary" @click="addCorrectConfig('spinsLostDay')">新增</el-button>
                <el-button type="primary" @click="saveRule('spinsLostDay')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="定时任务补偿" name="slotLimitDay">
            <el-row :gutter="10" class="mb8">
              <el-col :span="1.5">
                <el-upload
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=> { return importProbUploadSuccess(res, 'slotLimitDay')}"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:slotWeightChangeCfg:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>

              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:slotWeightChangeCfg:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportData('slotLimitDay')"
                >导出</el-button>
              </el-col>
            </el-row>
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.slotLimitDay" :key="index">
                <el-form-item label="次数">
                  <el-input v-model="item.key" style="width: 60px;" placeholder="体力总消耗" :prop="'formData.slotLimitDay.' +index +'.key'" />
                </el-form-item>
                <el-form-item v-for="(child, i, key) in item.value" :key="key" :label="enums[key]">
                  <el-input v-model.trim="item.value[i]" :value="child" style="width: 60px;" :prop="'formData.slotLimitDay.' +index+i" :placeholder="enums[key]" />
                </el-form-item>
                <el-form-item>
                  <el-button v-if="formData.slotLimitDay.length > 1" style="margin-top: 10px;" type="danger" @click="removeConfig(index, 'slotLimitDay')">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button type="primary" @click="addCorrectConfig('slotLimitDay')">新增</el-button>
                <el-button type="primary" @click="saveRule('slotLimitDay')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  exportSlotWeightChangeCfg,
  getSlotWeightChangeCfg, importSlotWeightChangeCfg,
  updateSlotWeightChangeCfg
} from '@/api/config/slot'
import { getToken } from '@/utils/auth'

export default {
  name: 'Index',
  data() {
    return {
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      activeName: 'betSpinsRule',
      formPhysicalExertion: {},
      rulesForPhysicalExertion: {},
      formData: {
        'betSpinsRule': {
          value: [{
            'k': 1,
            'v': 1
          }]
        },
        'spinsLost': [{
          key: 0,
          value: {
            '1': 1,
            '2': 2,
            '3': 3,
            '4': 4,
            '5': 5,
            '6': 6,
            '7': 1,
            '8': 1,
            '9': 1,
            '10': 1,
            '11': 1,
            '12': 1,
            '13': 1,
            '14': 1,
            '15': 1,
            '16': 1,
            '17': 1,
            '18': 1,
            '19': 1,
            '20': 1,
            '21': 1
          }
        }],
        'spinsLostDay': [{
          key: 0,
          value: {
            '1': 1,
            '2': 2,
            '3': 3,
            '4': 4,
            '5': 5,
            '6': 6,
            '7': 1,
            '8': 1,
            '9': 1,
            '10': 1,
            '11': 1,
            '12': 1,
            '13': 1,
            '14': 1,
            '15': 1,
            '16': 1,
            '17': 1,
            '18': 1,
            '19': 1,
            '20': 1,
            '21': 1
          }
        }],
        'slotLimitDay': [{
          key: 0,
          value: {
            '1': 1,
            '2': 2,
            '3': 3,
            '4': 4,
            '5': 5,
            '6': 6,
            '7': 1,
            '8': 1,
            '9': 1,
            '10': 1,
            '11': 1,
            '12': 1,
            '13': 1,
            '14': 1,
            '15': 1,
            '16': 1,
            '17': 1,
            '18': 1,
            '19': 1,
            '20': 1,
            '21': 1
          }
        }]
      },
      enums: ['打', '偷', '体力', '盾牌', '1金币', '2金币', '3金币', '1金币袋', '2金币袋', '3金币袋', '空', '1收集物', '2收集物', '3收集物', '小玩法物品1', '小玩法物品2', '小玩法物品3', '一个偷', '两个偷', '一个打', '两个打']
    }
  },
  created() {
    this.getTables('betSpinsRule')
  },
  methods: {
    handleClick(tab) {
      this.getTables(tab.name)
    },
    delRule(key) {
      this.formData.betSpinsRule.value = this.formData.betSpinsRule.value.filter((item, index) => {
        return index !== key
      })
    },
    addRule() {
      this.formData.betSpinsRule.value.push({ '0': 1 })
    },
    saveRule(name) {
      console.log('switch', name)
      const obj = {}
      switch (name) {
        case 'betSpinsRule':
          // eslint-disable-next-line no-case-declarations
          this.formData[name].value.forEach((item) => {
            obj[item.k] = parseFloat(item.v)
          })
          // eslint-disable-next-line no-case-declarations,no-undef
          break

        case 'spinsLost':
        case 'spinsLostDay':
        case 'slotLimitDay':
          this.formData[name].forEach((item, key) => {
            for (const key in item.value) {
              item.value[key] = parseFloat(item.value[key])
            }
            obj[item.key] = item.value
          })
          break
      }

      const data = JSON.stringify(obj)
      updateSlotWeightChangeCfg({ name: name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    // 添加修正配置
    addCorrectConfig(key) {
      this.formData[key].push({
        key: 0,
        value: {
          '1': 1,
          '2': 1,
          '3': 1,
          '4': 1,
          '5': 1,
          '6': 1,
          '7': 1,
          '8': 1,
          '9': 1,
          '10': 1,
          '11': 1,
          '12': 1,
          '13': 1,
          '14': 1,
          '15': 1,
          '16': 1,
          '17': 1,
          '18': 1,
          '19': 1,
          '20': 1,
          '21': 1
        }
      })
    },
    removeConfig(index, key) {
      this.formData[key] = this.formData[key].filter((item, i) => {
        return index !== i
      })
    },
    getTables(name) {
      console.log('getTables', name)
      getSlotWeightChangeCfg({ name: name }).then(res => {
        if (res.code === 200) {
          switch (name) {
            case 'betSpinsRule':
              this.formData[name].value = []
              for (const key in res.data) {
                this.formData[name].value.push({ k: key, v: res.data[key] })
              }
              break

            case 'spinsLost':
            case 'spinsLostDay':
            case 'slotLimitDay':
              this.formData[name] = []
              for (const key in res.data) {
                this.formData[name].push({
                  key: key,
                  value: res.data[key]
                })
              }
              break
          }
        }
      })
    },
    importProbUploadSuccess(response, name) {
      importSlotWeightChangeCfg({ data: response.data.path, name: name }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(name) {
      exportSlotWeightChangeCfg({ name: name }).then(res => {
        console.log(res)
        if (res.code === 200) {
          console.log(process.env.VUE_APP_BASE_API)
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          // downloadFile(res.data.path).then(res => {
          //   const url = window.URL.createObjectURL(new Blob([res.data]))
          //   const link = document.createElement('a')
          //   link.href = url
          //   link.setAttribute('download', name + '.xlsx') // 设置下载文件的文件名
          //   document.body.appendChild(link)
          //   link.click()
          // })
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
